export default [
  {
    iconLabel: 'Tractor',
    iconValue: 'tractor'
  },
  {
    iconLabel: 'Excavator',
    iconValue: 'excavator'
  },
  {
    iconLabel: 'Combine',
    iconValue: 'combine'
  },  
  {
    iconLabel: 'Self-propelled sprayer',
    iconValue: 'self-propelled-sprayer'
  },
  {
    iconLabel: 'Grader',
    iconValue: 'grader'
  },
  {
    iconLabel: 'Drainage',
    iconValue: 'drainage'
  },
  {
    iconLabel: 'Forage',
    iconValue: 'forage'
  },  
  {
    iconLabel: 'Surveyor',
    iconValue: 'surveyor'
  },
  {
    iconLabel: 'Boat',
    iconValue: 'boat'
  },
  {
    iconLabel: 'Car',
    iconValue: 'car'
  },
  {
    iconLabel: 'Emergency',
    iconValue: 'emergency'
  },  
  {
    iconLabel: 'Truck',
    iconValue: 'truck'
  },
  {
    iconLabel: 'UAV',
    iconValue: 'uav'
  },  
  {
    iconLabel: 'Others',
    iconValue: 'others'
  }
];
